import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'
import { ITrainingCategory } from '../../interfaces'

const getSortTrainingCategoriesMutationRequest = () => ({
  method: 'put',
  url: `${config.baseUrl}/TrainingCategories/sort`,
})

const useSortTrainingCategoriesMutation = (options = {}) => {
  const request = useMemo(() => getSortTrainingCategoriesMutationRequest(), [])

  const sortTrainingCategories = useCallback(
    async (data: ITrainingCategory) => axios({ ...request, data }).then(res => res.data),
    [request],
  )

  const response = useMutation<ITrainingCategory, Error, ITrainingCategory>(sortTrainingCategories, options)

  return response
}

export default useSortTrainingCategoriesMutation